import { ManagePlayTime } from '@/features/activity-reminder/manage-play-time'
import { useGetActivityReminderQuery } from '@/features/activity-reminder/use-get-activity-reminder-query'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { useToast } from '@vgw/multibrand-fe-toast'
import { useEffect } from 'react'

export const Route = createFileRoute('/_app/your-play/activity-reminder/')({
  component: ActivityReminderIndex,
})

function ActivityReminderIndex() {
  const {
    data: activityReminder,
    isPending,
    error,
  } = useGetActivityReminderQuery()
  const { t } = useLingui()
  const { show } = useToast()
  const navigate = useNavigate()

  useEffect(() => {
    if (error) {
      show({
        description: t`Something went wrong.`,
        variant: 'warning',
        close: false,
      })
    }
  }, [error, show, t])

  return (
    <TertiaryPageLayout
      headerText={t`Activity Reminder`}
      subheader={
        <div className="text-center font-family-display leading-6 text-content">{t`Stay informed about your gameplay and choose whether to keep playing.`}</div>
      }
      backButtonOnClick={() => navigate({ to: '/' })}
    >
      {isPending ? (
        <CircleLoadingAnimation className="mx-auto mt-[60px]" />
      ) : (
        <ManagePlayTime activityReminder={activityReminder} />
      )}
    </TertiaryPageLayout>
  )
}
